import React, { useEffect } from 'react';

export function PlayGround() {


  useEffect(() => {
    const script = document.createElement('script');
    script.src = '/dummy_script.js'; // Make sure it's moved to public/
    script.async = true;

 

    script.onload = () => {
      console.log("dummy_script.js loaded");
    };

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div>Render A sandbox client with dummy account</div>
  );
}
